import { useState } from 'react'

import { useRouter } from 'next/router'

import Footer from '@/components/organisms/Footer'
import Header from '@/components/organisms/Header'
import CropMap from '@/components/organisms/CropMap'
import Plants from '@/components/organisms/Plants'
import { useGetCurrentMilestone } from '@/services/milestone/hooks'
import { isObjectiveCompleted } from '@/utils/index'
import routes from '@/config/routes'

import ComponentStyled from './styled'

const BioDiversity = () => {
  const [isActivePlant, setIsActivePlant] = useState(false)
  const router = useRouter()

  const { data: currentMilestone } = useGetCurrentMilestone()
  const isCompleted = currentMilestone ? isObjectiveCompleted(currentMilestone) : false

  const handleClickBack = () => {
    if (isActivePlant) {
      router.reload()
    } else {
      router.push(routes.home)
    }
  }

  return (
    <ComponentStyled>
      <Header showBack showBtn={!isCompleted} onClickBack={handleClickBack} />
      <div className='global-page-wrapper'>
        <Plants onClickPlant={() => setIsActivePlant(true)} />
        <CropMap />
      </div>
      <Footer />
    </ComponentStyled>
  )
}

export default BioDiversity
